export enum Seller {
	IS_OSKAR = 'true',
	IS_NOT_OSKAR = 'false',
	ALL = '',
}
